/**
 * 玩家端本地存储的 key，H5 与小程序共用同一份字面量。
 * 改名会让老用户被当成新人，两端必须同时改，所以只在这里声明。
 */
export const storageKeys = {
  nickname: 'feltos_nickname',
  /** 玩家会话 JWT，服务端签发，不含 OpenID / session_key */
  playerToken: 'feltos_player_token',
  /** FeltOS 大厅最近一次选择的租户 */
  selectedTenantId: 'feltos_selected_tenant_id',
  /** 当前租户上下文的品牌名，只作展示缓存，服务端 `brandName` 是唯一来源 */
  brandName: 'feltos_brand_name',
  /** 当前租户标志，与品牌名一起缓存、一起清掉 */
  logoUrl: 'feltos_logo_url',
  /** 当前租户的前台皮肤 */
  clientTheme: 'feltos_client_theme',
  /** 裁判会话 JWT，与网页 cookie 同一套 AuthSession */
  staffToken: 'feltos_staff_token',
  /** 小程序管理员会话 JWT */
  bossToken: 'feltos_boss_token',
  /** 当前租户是否允许显示管理员入口 */
  bossVisible: 'feltos_boss_visible',
  /** 本地退出；OpenID 仍在，避免下次自动当成已登录 */
  loggedOut: 'feltos_logged_out',
  /** 玩家勾过「以后不再询问」，进桌不再自动弹登录；主动登录成功后清除 */
  loginMuted: 'feltos_login_muted',
  /** 已向用户展示过订阅消息引导；微信侧真实授权状态仍通过 getSetting 读取 */
  subscribeMessagePrompted: 'feltos_subscribe_message_prompted',
  /** 非生产 mock 登录凭证，接入真实微信登录后删除 */
  mockLoginCode: 'feltos_mock_login_code',
  /** 点单购物车，按座位码隔离，结账返回修改时继续用 */
  shopCart: 'feltos_shop_cart',
  /** 小程序排行榜上次选的口径、粒度、展示格式和成就 */
  rankingSelection: 'feltos_ranking_selection',
} as const
